import { post } from "../utils";

export default host => (channelId, livestreamId, token) =>
  post(`${host}/channels/${channelId}/livestreams/${livestreamId}/access`, JSON.stringify({ticket: token.toLowerCase()}))
    .then(response => response.json())